export default {
  enteringpayments: {
    title: "Entering payments"
  }
};
